module.exports = __webpack_public_path__ + "img/package_5_unlock.220c9d26.png";